import { Component } from '@angular/core';

@Component({
  selector: 'app-soc2',
  imports: [],
  templateUrl: './soc2.html',
  styleUrl: './soc2.css',
})
export class Soc2 {
  features = [
    {
      icon: '🎯',
      title: 'Trust Service Criteria',
      description: 'Implement controls across security, availability, processing integrity, confidentiality, and privacy.'
    },
    {
      icon: '📊',
      title: 'Type I & Type II',
      description: 'Support for both SOC 2 Type I (point-in-time) and Type II (operational effectiveness over time) audits.'
    },
    {
      icon: '🔒',
      title: 'Security Controls',
      description: 'Comprehensive security control implementation aligned with AICPA Trust Service Principles.'
    },
    {
      icon: '📝',
      title: 'Policy Development',
      description: 'Create and maintain security policies, procedures, and documentation required for SOC 2 compliance.'
    },
    {
      icon: '🔄',
      title: 'Continuous Compliance',
      description: 'Automated monitoring and evidence collection to maintain ongoing SOC 2 compliance readiness.'
    },
    {
      icon: '🤝',
      title: 'Audit Readiness',
      description: 'Complete preparation for third-party auditor assessments with organized evidence and documentation.'
    }
  ];

  process = [
    {
      number: 1,
      title: 'Readiness Assessment',
      description: 'Evaluate current controls against SOC 2 Trust Service Criteria and identify gaps.'
    },
    {
      number: 2,
      title: 'Control Implementation',
      description: 'Deploy required security controls, policies, and monitoring systems for compliance.'
    },
    {
      number: 3,
      title: 'Evidence Collection',
      description: 'Gather and organize evidence demonstrating control effectiveness over audit period.'
    },
    {
      number: 4,
      title: 'Third-Party Audit',
      description: 'Facilitate auditor assessment and achieve SOC 2 Type I or Type II certification.'
    }
  ];

  caseStudy = {
    title: 'SaaS Platform Earns SOC 2 Type II in Record Time',
    description: 'A fast-growing B2B SaaS platform needed SOC 2 Type II certification to close enterprise deals and compete with established players in their market.',
    challenge: 'No existing compliance framework, limited security documentation, and 6-month timeline to certification',
    solution: 'Rapid control implementation, automated evidence collection platform, and accelerated audit preparation',
    industry: 'SaaS',
    timeline: '7 Months',
    result: '$5M Revenue'
  };

  testimonial = {
    quote: 'HoneyKode made SOC 2 compliance achievable for our startup. They provided a clear roadmap, handled the heavy lifting, and helped us earn the trust of enterprise customers. Game-changing for our business.',
    author: 'Lisa Chen',
    role: 'CEO, DataFlow Analytics'
  };
}
